import { render, staticRenderFns } from "./VoyageReports.vue?vue&type=template&id=43dab6aa&"
import script from "./VoyageReports.vue?vue&type=script&lang=js&"
export * from "./VoyageReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports